import {TypedUseSelectorHook,useDispatch,useSelector} from "react-redux"
import type {RootState,AppDispatch,AppThunk} from "./store"

//use this method throughput application instead of plain `useDispatch` and useSelector

export const useAppDispatch: ()=> AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector